import y from "lodash/isEqual";
import o from "just-kebab-case";
function u(t) {
  return t ? t.elm.nodeType === 1 && t.data.directives && t.data.directives.some((e) => e.name === "pendo-analytics") : !1;
}
function f({ value: t, arg: e }) {
  const n = typeof t;
  return n === "string" ? e : t && n === "object" ? t.type : !1;
}
function c(t) {
  const e = typeof t;
  return e === "string" ? t : t && e === "object" ? t.value : !1;
}
function p(t, { value: e, type: n } = {}) {
  if (n) {
    t.setAttribute("pendo-analytics", `${n}:${o(e)}`);
    return;
  }
  t.setAttribute("pendo-analytics", o(e));
}
function d(t, { value: e, arg: n }, i) {
  if (i.isRootInsert && i.parent && u(i.parent))
    return;
  const r = c(e), s = f({
    value: e,
    arg: n
  });
  r && p(t, {
    value: r,
    type: s
  });
}
function b(t, { oldValue: e, value: n, arg: i }, r) {
  if (r.isRootInsert && r.parent && u(r.parent) || y(e, n))
    return;
  const s = c(n), l = f({ value: n, arg: i });
  s && p(t, { value: s, type: l });
}
function a(t) {
  a.installed || (a.installed = !0, t.directive("pendo-analytics", m));
}
const m = {
  mounted: d,
  updated: b,
  install: a
};
export {
  m as PendoAnalytics,
  p as applyAttributes,
  m as default,
  f as getType,
  c as getValue,
  a as install,
  d as mounted,
  b as updated
};
//# sourceMappingURL=pendo-analytics.js.map
